import type { PostgrestError } from '@supabase/supabase-js'
import { NotFoundError, SupabaseError } from '../errors'

/**
 * Unwrap padrão de uma chamada Supabase `select().single()` / `maybeSingle()`.
 * `notFoundEntity` define o nome usado em `NotFoundError` quando data === null.
 */
export function unwrapSingle<T>(
  result: { data: T | null; error: PostgrestError | null },
  notFoundEntity: string,
  identifier?: string | number,
): T {
  if (result.error) throw new SupabaseError(result.error.message, result.error)
  if (result.data === null) throw new NotFoundError(notFoundEntity, identifier)
  return result.data
}

/**
 * Unwrap de uma listagem. Retorna `[]` se data === null (Supabase faz isso).
 */
export function unwrapList<T>(result: { data: T[] | null; error: PostgrestError | null }): T[] {
  if (result.error) throw new SupabaseError(result.error.message, result.error)
  return result.data ?? []
}

/**
 * Variante de single que aceita null (não lança NotFoundError).
 */
export function unwrapMaybe<T>(result: { data: T | null; error: PostgrestError | null }): T | null {
  if (result.error) throw new SupabaseError(result.error.message, result.error)
  return result.data
}
